import React, {PropsWithChildren} from 'react';
import {ArrivalPropertyContext, type ArrivalProperty} from './ArrivalPropertyContext';

function ArrivalPropertyProvider({
  value,
  children,
}: PropsWithChildren<{value: ArrivalProperty}>) {
  return (
    <ArrivalPropertyContext.Provider value={value}>
      {children}
    </ArrivalPropertyContext.Provider>
  );
}

export {ArrivalPropertyProvider};
